import { Directive, Input, OnChanges } from '@angular/core';

@Directive({
    selector: '[appBodybg]',
    standalone: false
})
export class BodybgDirective implements OnChanges {
  @Input('appBodybg') appBodybg: string;

  constructor() {}

  ngOnChanges(data) {
    if (data.appBodybg) {
      document
        .getElementById('main')
        .classList.remove(
          'bg-home',
          'bgfc21',
          'bgfcb',
          'bghistory',
          'bghistoryfc21',
          'bghistoryfc21mobile'
        );
      document.getElementById('main').classList.add(this.appBodybg);
      document.body.classList.remove(
        'bg-home',
        'bgfc21',
        'bgfcb',
        'bghistory',
        'bghistoryfc21',
        'bghistoryfc21mobile'
      );
      document.body.classList.add(this.appBodybg);
    }
  }
}
